import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../ui-components';
import { classNames } from '../../utils/tailwind/classNames';

export const AvailabilityMessage: FC<{ availableToSell: number; className?: string }> = ({
    availableToSell,
    className,
}) => {
    if (availableToSell > 0) {
        return (
            <div
                data-testid="quantity-message-not-available"
                className={classNames('flex flex-col', className)}
            >
                <Text size="small" color="slt-red.1000" align={{ 'lg-sm': 'right' }}>
                    <FormattedMessage
                        id="quantity.message.items.available"
                        defaultMessage="{availableToSell, plural, one {# item} other {# items}} available."
                        values={{
                            availableToSell,
                        }}
                    />
                </Text>
                <Text size="small" color="slt-red.1000">
                    <FormattedMessage
                        id="quantity.message.adjust"
                        defaultMessage="Please adjust quantity."
                    />
                </Text>
            </div>
        );
    }

    return (
        <div
            data-testid="quantity-message-out-of-stock"
            className={classNames('flex flex-col', className)}
        >
            <Text size="small" color="slt-red.1000" align={{ 'lg-sm': 'right' }}>
                <FormattedMessage
                    id="quantity.message.out.of.stock"
                    defaultMessage="This item is out of stock. Please remove it to continue."
                />
            </Text>
        </div>
    );
};

AvailabilityMessage.defaultProps = {
    className: undefined,
};
